import axios from 'axios'
// 打包需要配置环境
const currentEnv = 'product';

export function baseConfig (val = currentEnv){
  switch(val){
    case 'develop':
      return {
        baseURL:'https://testdemo.glu2u.com/prod-api'
      }
      break;
    case 'product':
        return {
          baseURL:'/prod-api'
        }
        break;
  }

}
console.log(baseConfig(currentEnv).baseURL,'0000000000000');

export const baseInstance = axios.create({
  // https://testdemo.glu2u.com/prod-api
  // baseURL: process.env.NODE_ENV === 'development' ? '/dev-api' : 'https://cgm.glu2u.com/prod-api',
  // baseURL: process.env.NODE_ENV === 'development' ? '/dev-api' : 'https://testdemo.glu2u.com/prod-api',
  baseURL: process.env.NODE_ENV === 'development' ? '/dev-api' : baseConfig(currentEnv).baseURL,
  timeout: 30000
});


/**
 * 主请求拦截器
 **/ 
baseInstance.interceptors.request.use((config) => {
  console.log('config: ', config)
  return config;
}, (error) => {
  console.log('error: ', error)
  return Promise.reject(error);
});
baseInstance.interceptors.response.use((response) => {
  console.log('response: ', response)
  if (response.status === 200) {
    return response.data
  }
  return Promise.reject(response)
  // 对响应数据做点什么
  // return response;
}, (error) => {
  console.log('error: ', error)
  return Promise.reject(error);
});


